import AxiosInterceptor from "api/interceptor";

const attribute = new AxiosInterceptor();

export default {
  get(inputs = { page: 1, limit: 10 }) {
    inputs.page = inputs.page ? inputs.page : 1;
    inputs.limit = inputs.limit ? inputs.limit : 10;
    return attribute.get(
      "/attribute?limit=" + inputs.limit + "&page=" + inputs.page
    );
  },
  delete(id) {
    return attribute.delete("/attribute/" + id);
  },
  create(inputs) {
    return attribute.post("/attribute", inputs);
  },
  getByType(type_id) {
    return attribute.get("/attribute/type/" + type_id);
  },

  getByTypeName(type_name) {
    return attribute.get("/attribute/type_name/" + type_name);
  },

  getRegions() {
    return attribute.get("/attribute/regions");
  }
};
